import { render, staticRenderFns } from "./EnterAuthTokenForm.vue?vue&type=template&id=6b8770a4&scoped=true&"
import script from "./EnterAuthTokenForm.vue?vue&type=script&lang=js&"
export * from "./EnterAuthTokenForm.vue?vue&type=script&lang=js&"
import style0 from "./EnterAuthTokenForm.vue?vue&type=style&index=0&id=6b8770a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8770a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
